import React, { useMemo, useState } from 'react';
import ToolkitBatchPage from './toolkit/ToolkitBatchPage';
import { sourceRow } from './toolkit/useToolkitBatch';

// Sync › project › Toolkit › OOO — ported from the desktop's OHIP › OOO. Each room in a v5 Out-of-Order-by-Reason
// report (HKOOOBYREASON XML, or a delimited export) in OO or OS status is put out of order / out of service in Opera
// Cloud for its date range (toolkit property.js post-ooo).
//
// REASON CODES differ between v5 and Opera Cloud, so each v5 code is translated through the map below before it is
// sent; a code with no entry is sent as it is. The map starts from the one built into the desktop app — it was written
// for one property, so check it against this one's Opera Cloud reason codes before running.

const DESKTOP_REASON_MAP = 'TUB=BAT, CAR=CAR, CEI=CEI, DIP=DIP, EAR=EAR, ENT=ENT, STO=FUR, CLO=HSK, LAST=LAST, LATE=LATE, '
    + 'PM=MAI, MGT=MGT, MOCK=MOCK, ONE ON ONE=ONE, REV=REV, SALES=SALES, UNGA=UNGA';

const COLUMNS = [
    { key: 'ROOM', label: 'Room' },
    { key: 'ROOM_STATUS', label: 'OO / OS' },
    { key: 'REASON_CODE', label: 'v5 reason' },
    { key: 'REASON_DESC', label: 'Description' },
    { key: 'BEGIN_DATE', label: 'From' },
    { key: 'END_DATE', label: 'To' },
    { key: 'RETURN_STATUS', label: 'Return status' },
    { key: 'result', label: 'Result' },
];

const parseMap = (text) => Object.fromEntries(String(text).split(',')
    .map((pair) => pair.split('=').map((s) => s.trim()))
    .filter(([k, v]) => k && v)
    .map(([k, v]) => [k.toUpperCase(), v]));

function ToolkitOooPage() {
    const [mapText, setMapText] = useState(DESKTOP_REASON_MAP);
    const reasonMap = useMemo(() => parseMap(mapText), [mapText]);
    const request = (row) => ({ area: 'property', op: 'post-ooo', args: { record: sourceRow(row, ['result']), reasonMap } });
    return (
        <ToolkitBatchPage title="OOO / OOS"
            subtitle="Put rooms out of order or out of service in Opera Cloud from an Opera v5 Out of Order by Reason report."
            fileTitle="Opera v5 OOO report" fileLabel="Choose HKOOOBYREASON (XML or CSV)" accept=".xml,.rep,.csv,.txt"
            kind="ooo" columns={COLUMNS} searchKeys={['ROOM', 'REASON_CODE', 'REASON_DESC']} exportName="OOO"
            request={request} server={{ screen: 'ooo', title: 'OOO / OOS', keyOf: (row) => row.ROOM }}
            options={(
                <label className="tkb-inline" style={{ maxWidth: '100%' }}>
                    <span>Reason codes, v5 = Opera Cloud ({Object.keys(reasonMap).length} mapped)</span>
                    <textarea rows={3} value={mapText} onChange={(e) => setMapText(e.target.value)} className="tkb-textarea" />
                </label>
            )} />
    );
}

export default ToolkitOooPage;
